import { applyLanguage, useTranslation } from "@repo/i18n";

const LANGS = [
  { value: "fr", label: "Français" },
  { value: "en", label: "English" },
] as const;

/**
 * In-place FR/EN switch (features/localization-i18n.md R7): swaps i18next + `<html lang>` + persists
 * to `sessionStorage` (via `@repo/i18n`'s `applyLanguage`) with NO navigation and NO second URL.
 * react-i18next re-renders every consumer on `languageChanged`, so `aria-pressed` follows the active
 * language without local state. A labelled radiogroup, keyboard-operable — axe-clean.
 */
export function LanguageControl() {
  const { t, i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "fr";

  return (
    <fieldset className="rsv-lang" aria-label={t("widget.language")}>
      {LANGS.map((lang) => (
        <button
          key={lang.value}
          type="button"
          lang={lang.value}
          aria-pressed={current === lang.value}
          onClick={() => {
            if (current !== lang.value) void applyLanguage(lang.value);
          }}
        >
          {lang.label}
        </button>
      ))}
    </fieldset>
  );
}
